import { useAuth } from '../../lib/auth';
import s from './login.module.css';

/** Tela única de login — a SPA inteira é atrás do login, não tem rota pública (ADR 0019 §1). */
export function LoginScreen() {
  const { login, error, status } = useAuth();

  return (
    <div className={s.wrap}>
      <div className={s.card}>
        <span className={s.mark} aria-hidden="true">
          S
        </span>
        <h1>Painel Storeo</h1>
        <p>Entre com sua conta de parceiro para gerenciar sua loja.</p>
        {error ? <p className={s.error}>{error}</p> : null}
        <button className={s.enter} onClick={login} disabled={status === 'checking'}>
          Entrar
        </button>
      </div>
    </div>
  );
}
